import { HeaderProps } from "@/composite/Header";
import { HeaderBlockProps, UserInfo } from "./client";

function buildCustomerLinks(
	userInfo: UserInfo,
	props: HeaderBlockProps
): HeaderProps<any, any>["utilityLinks"]["findLinks"] {
	const { isPartyHost } = userInfo;
	if (isPartyHost) {
		const hostDashboardUrl =
			userInfo.hostDashboardUrl ??
			props.consultant_show_association_links.host_dashboard.href;

		return [
			{
				visibility: "desktop",
				link: {
					children:
						props.consultant_show_association_links.find_a_show
							.title,
					href: props.consultant_show_association_links.find_a_show
						.href
				}
			},
			{
				visibility: "desktop",
				link: {
					children:
						props.consultant_show_association_links
							.find_a_consultant.title,
					href: props.consultant_show_association_links
						.find_a_consultant.href
				}
			},
			{
				visibility: "both",
				link: {
					children:
						props.consultant_show_association_links.host_dashboard
							.title,
					href: hostDashboardUrl
				}
			},
			{
				visibility: "both",
				link: {
					children:
						props.consultant_show_association_links.my_shows.title,
					href: props.consultant_show_association_links.my_shows.href
				}
			}
		];
	}
	return [
		{
			visibility: "desktop",
			link: {
				children:
					props.consultant_show_association_links.find_a_show.title,
				href: props.consultant_show_association_links.find_a_show.href
			}
		},
		{
			visibility: "both",
			link: {
				children:
					props.consultant_show_association_links.find_a_consultant
						.title,
				href: props.consultant_show_association_links.find_a_consultant
					.href
			}
		},
		{
			visibility: "both",
			link: {
				children:
					props.consultant_show_association_links.my_shows.title,
				href: props.consultant_show_association_links.my_shows.href
			}
		}
	];
}

function buildConsultantLinks(
	userInfo: UserInfo,
	props: HeaderBlockProps
): HeaderProps<any, any>["utilityLinks"]["findLinks"] {
	const { isPartyHost } = userInfo;
	if (isPartyHost) {
		return [
			{
				visibility: "both",
				link: {
					children:
						props.consultant_show_association_links.find_a_show
							.title,
					href: props.consultant_show_association_links.find_a_show
						.href
				}
			},
			{
				visibility: "both",
				link: {
					children:
						props.consultant_show_association_links.host_dashboard
							.title,
					href:
						userInfo.hostDashboardUrl ??
						props.consultant_show_association_links.host_dashboard
							.href
				}
			},
			{
				visibility: "both",
				link: {
					children:
						props.consultant_show_association_links.my_shows.title,
					href: props.consultant_show_association_links.my_shows.href
				}
			}
		];
	}
	return [
		{
			visibility: "both",
			link: {
				children:
					props.consultant_show_association_links.find_a_show.title,
				href: props.consultant_show_association_links.find_a_show.href
			}
		},
		{
			visibility: "both",
			link: {
				children:
					props.consultant_show_association_links.my_shows.title,
				href: props.consultant_show_association_links.my_shows.href
			}
		}
	];
}

function buildAnonymousLinks(
	_userInfo: UserInfo,
	props: HeaderBlockProps
): HeaderProps<any, any>["utilityLinks"]["findLinks"] {
	return [
		{
			visibility: "mobile",
			link: {
				children:
					props.consultant_show_association_links.find_a_consultant
						.title,
				href: props.consultant_show_association_links.find_a_consultant
					.href
			}
		},
		{
			visibility: "both",
			link: {
				children:
					props.consultant_show_association_links.find_a_show.title,
				href: props.consultant_show_association_links.find_a_show.href
			}
		},
		{
			visibility: "desktop",
			link: {
				children:
					props.consultant_show_association_links.find_a_consultant
						.title,
				href: props.consultant_show_association_links.find_a_consultant
					.href
			}
		}
	];
}

export function determineLinks(
	userInfo: UserInfo,
	props: HeaderBlockProps
): HeaderProps<any, any>["utilityLinks"]["findLinks"] {
	switch (userInfo.userType) {
		case "customer":
			return buildCustomerLinks(userInfo, props);
		case "consultant":
			return buildConsultantLinks(userInfo, props);
		case "anonymous":
		default:
			return buildAnonymousLinks(userInfo, props);
	}
}
